import { useFormik } from "formik";
import * as Yup from "yup";
import { DEFAULT_SEARCH_PARAMS } from "../types/profile_search_params";
import { handleFormikArray } from "../utils/formikArrayHandling";
import { V3GetFormattedDate } from "../components/V3Date";
import { useState } from "react";
import { SearchContentFormik } from "../types/content-search";
import { makeIdFromLength } from "../utils/makeIdFromLength";

export const useContentSearch = (searchArgs: SearchContentFormik, onSearchFormSubmit: (data: SearchContentFormik) => void, skipScrollTop = false) => {
    const [searchKey, setSearchKey] = useState("");

    const resetSearchKey = () => {
        setSearchKey(makeIdFromLength(40));
    };

    let from, to;

    if (searchArgs?.nodate) {
        from = undefined;
        to = undefined;
    } else {
        from = searchArgs?.from || DEFAULT_SEARCH_PARAMS.FROM;
        to = searchArgs?.to || DEFAULT_SEARCH_PARAMS.TO;
    }

    const searchContentFormik = useFormik<SearchContentFormik>({
        enableReinitialize: true,
        initialValues: {
            source: searchArgs.source || [],
            text: searchArgs.text || "",
            type: searchArgs.type || [],
            subAccount: searchArgs.subAccount || [],
            from,
            to,
            sort: searchArgs.sort
        },
        onSubmit: (data) => {
            if (!skipScrollTop) window.scrollTo(0, 0);
            resetSearchKey();
            onSearchFormSubmit({ ...data });
        },
        validationSchema: Yup.object().shape({
            source: Yup.array().of(Yup.string()),
            text: Yup.string(),
            type: Yup.array().of(Yup.string())
        })
    });

    const handleContentFormikArray = handleFormikArray<SearchContentFormik>(searchContentFormik);

    const IS_ACTIVE_FILTER_SEARCH =
        !!searchContentFormik.values.source.length ||
        !!searchContentFormik.values.subAccount.length ||
        !!searchContentFormik.values.type.length ||
        searchContentFormik.values.from !== DEFAULT_SEARCH_PARAMS.FROM;

    const clearContentPageLeftFilters = () => {
        searchContentFormik.setFieldValue("source", []);
        searchContentFormik.setFieldValue("subAccount", []);
        searchContentFormik.setFieldValue("type", []);
        searchContentFormik.setFieldValue("from", null);
        searchContentFormik.setFieldValue("to", null);
        searchContentFormik.setFieldValue("text", "");
        searchContentFormik.setFieldValue("sort", undefined);
        searchContentFormik.submitForm();
    };

    const { formattedFromDate, formattedToDate } = V3GetFormattedDate(searchContentFormik.values.from, searchContentFormik.values.to);

    return {
        formattedFromDate,
        formattedToDate,
        searchContentFormik,
        IS_ACTIVE_FILTER_SEARCH,
        handleContentFormikArray,
        clearContentPageLeftFilters,
        searchKey,
        resetSearchKey
    };
};
